export default __webpack_public_path__ + "static/media/scarredhide.f501346f.png";